import { render, staticRenderFns } from "./RenderAd.vue?vue&type=template&id=123dac7c&"
import script from "./RenderAd.vue?vue&type=script&lang=js&"
export * from "./RenderAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports